
//
// Voucher-related Pages Controller
//

module.exports = function VouchersController ($page, $$) {

  //
  // Voucher creation and modification forms
  //

  // Show reference line

  $$('[data-show-reference-line]').on('click', function () {
    $(this).hide();
    $$('[data-reference-line]').removeClass('hidden');
  });


  // Hook up voucher preview buttons with form data

  $$('form').each(function () {
    var $form = $(this);
    var previewModal = getWidgetAtDom($$('[data-modal="preview"]'));

    $(this).find('[data-voucher-preview-trigger]').each(function () {
      var $previewButton = $(this);

      $previewButton.on('click', function () {
        previewModal.invoke($previewButton.data('voucher-preview-id'), $form.serialize());
      });
    });
  });

}

